import "core-js/modules/es6.function.name";
//
//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
import { chartMixins } from './chartMixins';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartBar',
  mixins: [chartMixins],
  props: {
    value: Array,
    text: String,
    subtext: String
  },
  data: function data() {
    return {
      dom: null
    };
  },
  watch: {
    value: function value(newVal) {
      if (this.dom) {
        this.setOption(newVal);
      } else {
        this.init();
      }
    }
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setParams: function setParams(value) {
      var xAxisData = value.map(function (_) {
        return _.name;
      });
      var seriesData = value.map(function (_) {
        return _.value;
      });
      var dataShadow = [];

      for (var i in value) {
        dataShadow.push(500);
      }

      this.option = {
        title: {
          x: 'center'
        },
        grid: {
          left: '3%',
          top: '6%',
          right: '4%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          splitLine: {
            show: false
          },
          axisLabel: {
            show: true,
            color: '#fff'
          },
          axisTick: {
            show: false
          },
          //不显示刻度
          axisLine: {
            show: false
          },
          boundaryGap: false,
          //坐标轴两边留白策略
          data: xAxisData
        }],
        yAxis: [{
          type: 'value',
          boundaryGap: false,
          position: 'left',
          splitLine: {
            show: true,
            lineStyle: {
              color: '#006EA7'
            }
          },
          //区域中分隔线
          axisLabel: {
            show: true,
            color: '#fff'
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: '#006EA7'
            }
          },
          //不显示刻度
          axisLine: {
            show: false
          }
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        barWidth: 15,
        series: [{
          data: seriesData,
          type: 'bar',
          backgroundStyle: {
            color: '#3a4959'
          },
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#83bff6'
            }, {
              offset: 0.5,
              color: '#188df0'
            }, {
              offset: 1,
              color: '#188df0'
            }])
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#2378f7'
              }, {
                offset: 0.7,
                color: '#2378f7'
              }, {
                offset: 1,
                color: '#83bff6'
              }])
            }
          },
          label: {
            color: '#fff'
          },
          yAxisIndex: 0,
          xAxisIndex: 0
        }, {
          type: 'line',
          data: seriesData,
          lineStyle: {
            color: 'yellow'
          }
        }]
      };
      return this.option;
    },
    init: function init() {
      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.setOption(this.setParams(this.value));
      on(window, 'resize', this.resize);
    },
    setOption: function setOption(value) {
      this.dom.setOption(this.setParams(value));
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.init();
    });
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};